import React from 'react';
import * as RT from '../../../constants/Routing';

import { Redirect } from 'react-router-dom';
import DetailCommunity from '../Detail'

export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      previewBack: false
    }
  }

  backToForm = () => {
    const selectedCommunity = this.props.Community.previewCommunity
    const id = selectedCommunity.id
    const { history } = this.props

    this.props.communityPreviewBack()

    this.setState({ previewBack: true }, () => {
      history.push(RT.COMMUNITY_EDIT_PATH.replace(/:id/, id))
    })
  }

  componentWillUnmount = () => {
    // this.props.communityPreviewDelete()
    if (!this.state.previewBack) {
      this.props.communityAllReset()
    }
  }

  componentWillMount = () => {
    const selectedCommunity = this.props.Community.previewCommunity

    if (!selectedCommunity) {
      const { history } = this.props
      history.push(RT.USER_MYPAGE_PATH)
    }
  }

  componentWillUpdate = () => {
    const selectedCommunity = this.props.Community.previewCommunity
    const { history } = this.props

    if (this.props.Community.updateLoaded && !!selectedCommunity) {
      history.push(RT.COMMUNITY_EDIT_PATH.replace(/:id/, selectedCommunity.id))
    } else if (this.props.Community.publishLoaded && !!selectedCommunity) {
      history.push(RT.COMMUNITY_EDIT_PATH.replace(/:id/, selectedCommunity.id))
    } else {
    }
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const selectedCommunity = this.props.Community.previewCommunity
    const currentPath = this.props.router.location.pathname

    return (
      <DetailCommunity
        currentUser={currentUser}
        currentPath={currentPath}
        circle={selectedCommunity}
        preview={true}
        backToForm={this.backToForm}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/Preview/Preview.jsx